
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5349_37459)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_5349_37459)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2.5c-1.124 0-3.087.274-4.803 1.41C5.418 5.09 4 7.143 4 10.455c0 3.347 1.95 6.342 3.745 8.411a25.515 25.515 0 003.335 3.19c.101.08.182.142.238.184l.066.05.019.013.006.005h.001l.001.001L12 21.5l-.588.809a1 1 0 001.176 0L12 21.5c.588.809.588.808.589.808l.002-.002.006-.004.018-.013.066-.05a22.629 22.629 0 001.068-.873 25.524 25.524 0 002.506-2.5C18.051 16.795 20 13.8 20 10.453c0-3.312-1.418-5.364-3.198-6.543C15.087 2.774 13.123 2.5 12 2.5zm.438 17.357c-.162.14-.309.264-.438.37a23.521 23.521 0 01-2.745-2.673C7.551 15.59 6 13.063 6 10.455c0-2.641 1.082-4.067 2.302-4.876C9.587 4.726 11.123 4.5 12 4.5c.877 0 2.413.226 3.697 1.078C16.919 6.387 18 7.813 18 10.454c0 2.608-1.55 5.136-3.255 7.1a23.516 23.516 0 01-2.307 2.303zM10 10.5a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z","fill":"#161616","fill-opacity":".72"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5349_37459"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_5349_37459"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    